module.exports = __webpack_public_path__ + "img/logo-1.1d19e319.png";